import * as React from 'react'

import { Select as SelectPrimitive } from '@base-ui/react/select'
import { observer } from 'mobx-react'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
} from '~/client/src/shared/components/shadcn-ui/select'
import StruxhubTextValueSelector from '~/client/src/shared/components/StruxhubInputs/StruxhubSelector/StruxhubTextValueSelector'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import BaseGroupingOptionsStore, {
  EMPTY_OPTION,
  ICustomBandOption,
  INDENT_OPTION_MAIN_ID,
} from '../../BaseGroupingOptions.store'

import '../../BaseGroupingOptions.scss'

// localization: translated

interface IProps {
  store: BaseGroupingOptionsStore
}

@observer
export default class CustomBandCreation extends React.Component<IProps> {
  public render() {
    return (
      <>
        <div className="text bold large pb5 mb10 bb-light-grey">
          {Localization.translator.customGroupCreation}
        </div>
        <div className="relative col scrollable mb15 min-height130">
          {this.renderBandRow()}
        </div>
      </>
    )
  }

  private renderBandRow(index: number = 0) {
    const { groupLevels, options, maxCustomBandsLevel } = this.props.store
    if (index + 1 > maxCustomBandsLevel || index >= groupLevels.length) {
      return
    }

    const level = groupLevels[index]
    const items = options
      .filter(
        ({ name }) => !name || level === name || !groupLevels.includes(name),
      )
      .filter(
        ({ name }, idx, filtered) =>
          name !== INDENT_OPTION_MAIN_ID ||
          filtered[idx - 1]?.name !== INDENT_OPTION_MAIN_ID,
      )
    const selectedItem = options.find(o => o.name === level)
    const selectedValue = (selectedItem?.name && selectedItem?.caption) || ''

    return (
      <div key={index} className="row y-start pr10 y-stretch mt5">
        <div className="activity-log-entry-left-col col no-grow mr10 mt5">
          <div className="band-left-column-dot brada10 mb5 ml8" />
          <div className="relative-block thread-line-centred">
            <div className="text center absolute-block" />
            <div className="thread-vertical-line" />
          </div>
        </div>
        <div className="col">
          <>
            <div className="ml5 text">
              {Localization.translator.bandX(index + 1)}
            </div>
            <Select
              value={level}
              onValueChange={this.setLevel.bind(this, index)}
            >
              <SelectPrimitive.Trigger
                nativeButton={false}
                render={<div className="mw300" />}
              >
                <StruxhubTextValueSelector
                  isMinimalisticMode={true}
                  value={selectedValue}
                />
              </SelectPrimitive.Trigger>
              <SelectContent className="tw:w-[300px] tw:max-h-[300px]">
                {items.map(this.renderGroupingItem)}
              </SelectContent>
            </Select>
          </>
          {this.renderBandRow(index + 1)}
        </div>
      </div>
    )
  }

  private setLevel(levelIndex: number, name: string) {
    const { store } = this.props
    if (name === store.groupLevels[levelIndex]) {
      return
    }

    switch (true) {
      case levelIndex === store.groupLevels.length - 1:
        store.groupLevels[levelIndex] = name
        store.groupLevels.push(EMPTY_OPTION)
        return
      case !name && !levelIndex:
        store.groupLevels = [EMPTY_OPTION]
        return
      case !name && !!levelIndex:
        store.groupLevels.splice(
          levelIndex,
          store.groupLevels.length - levelIndex - 1,
        )
      // eslint-disable-next-line no-fallthrough
      default:
        store.groupLevels[levelIndex] = name
        return
    }
  }

  private renderGroupingItem = (
    option: ICustomBandOption,
    index: number,
  ): JSX.Element => {
    if (option.name === INDENT_OPTION_MAIN_ID) {
      return <SelectSeparator key={option.name + index} />
    }

    return (
      <SelectItem key={option.name + index} value={option.name}>
        {option.caption}
      </SelectItem>
    )
  }
}
